/** `X-Request-Timeout` 헤더 값 — 클라이언트·Next 프록시 모두 요청별 타임아웃 비활성화 */
export const REQUEST_TIMEOUT_NONE = 'none';

/** 페이지네이션 리스트 기본 페이지 사이즈 (product/banner 등 리스트 공통) */
export const DEFAULT_PAGE_SIZE = 30 as const;

/**
 * 장시간 실행되는 작업용 타임아웃 (5분).
 * 기본 `ENV.API_TIMEOUT`(20초)으로는 부족한 작업(예: 이미지 에셋 복사/가공 등)에 사용.
 * 무제한이 필요한 대용량 업로드는 `timeout: null`을 사용.
 */
export const LONG_API_TIMEOUT_MS = 5 * 60 * 1000;

export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  TIMEOUT: 408,
  CONFLICT: 409,
  UNPROCESSABLE_ENTITY: 422,
  INTERNAL_SERVER_ERROR: 500,
  NOT_IMPLEMENTED: 501,
  BAD_GATEWAY: 502,
  SERVICE_UNAVAILABLE: 503,
  WEB_SERVER_DOWN_ERROR: 521,
  CUSTOM_ERROR: 522,
} as const;
